export const saveData=(key,value)=>{
    localStorage.setItem(key,JSON.stringify(value))
    return 
}
export const getData=(key)=>{
    let data=JSON.parse(localStorage.getItem(key))
    return data
}